import React from "react";
import List from "../components/list";
import ListItem from "../components/list-item";
import Doctor from "../components/doctor";
import Spinner from "../components/spinner";
import View from "./view";
import messages from "../../../messages";
import config from "../../../config";
import SearchIcon from "material-ui/svg-icons/action/search";
import TextField from "material-ui/TextField";
import IconButton from "material-ui/IconButton";
import ClearIcon from "material-ui/svg-icons/content/clear";

export default class DoctorView extends View {
    static get title() {
        return "выберите врача";
    }

    static get titleShort() {
        return "врач";
    }

    static get defaultProps() {
        return Object.assign({}, super.defaultProps, {
            service: null,
            /*openWithoutDoctor: 0,*/
        });
    }

    static get propTypes() {
        return Object.assign({}, super.propTypes, {
            clinic: React.PropTypes.number.isRequired,
            specialization: React.PropTypes.number,
            service: React.PropTypes.string,
        });
    }
    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    constructor(props) {
        super(props);

        this.state = Object.assign({}, this.state, {
            items: null,
            visibleItems: null,
            term: "",
        });

        this._isMounted = false;
    }

    fetchData() {
        this.hideErrorMessage();
        this.setState({
            items: null,
            visibleItems: null,
        });

        const service = this.props.service === null ? "0" : this.props.service;
        const clinic = this.props.clinic;


        const url = `${config.dataUrl}api.php?function=doctors` +
            `&clinic=${clinic}` +
            `&service=${service}`;

        fetch(url).then((response) => {
            return response.json();

        }).then((responseJson) => {
            if (this._isMounted === true) {
                if (responseJson.status === true) {
                    let sorted = responseJson.doctors.sort(
                        (a, b) => a.name.localeCompare(b.name));


                    if (this.props.openWithoutDoctor /*&& props.doctorsIds.length()*/){

                        console.log('doctorsIds',this.props.doctorsIds);

                        sorted = sorted.filter((item) => {
                            console.log('item.id',item.id);
                            return this.props.doctorsIds.indexOf(item.id) > -1
                        })
                    }
                    this.setState({
                        visibleItems: sorted,
                        items: sorted,
                    });
                } else {
                    this.showErrorMessage(responseJson.description);
                }
            }
        }).catch((error) => {
            if (this._isMounted === true) {
                this.showErrorMessage(messages["REQUEST_FAILED"]);
            }
        });
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleRetryClick() {
        this.fetchData();
    }
    handleSearchFieldChanged = (item, value) => {
        if (!this.state.clearButtonEnabled && value.length > 0) {
            this.setState({ clearButtonEnabled: true });
        }

        if (this.state.clearButtonEnabled && value.length === 0) {
            this.setState({ clearButtonEnabled: false });
        }

        this.getSearchResult(value);

        this.setState({
            term: value
        });
    }
    handleClearButtonTap() {
        this.setState({
            term: ""
        });

        this.getSearchResult("");
    }
    getSearchResult(term) {
        if (term.length === 0){
            this.setState({
                visibleItems: this.state.items,
            });
        }else{
            const termToLower = term.toLowerCase();
            const filtred = this.state.items.filter(item => item.name.toLowerCase().indexOf(termToLower) > -1);
            this.setState({
                visibleItems: filtred,
            });
        }
    }
    renderSearchInput() {
        this.colors = this.context.muiTheme.palette;
        return <div className="search-box__container">
            <SearchIcon className="search-box__search-icon"/>

            <TextField
                className="search-box__term"
                fullWidth={true}
                name="searchBoxTerm"
                onChange={this.handleSearchFieldChanged}
                placeholder="найти специалиста"
                value={this.state.term}/>

            <IconButton
                className="search-box__clear-button"
                disabled={!this.state.clearButtonEnabled}
                onTouchTap={() => this.handleClearButtonTap()}>
                <ClearIcon
                    color={this.colors.primary3color}
                    hoverColor={this.colors.accent1color}
                />
            </IconButton>
        </div>;
    }

    renderContent() {
        if (this.state.isErrorMessageVisible === true) {
            return this.renderErrorMessage();
        }

        if (this.state.items === null) {
            return <Spinner/>;
        }

        if (this.state.term.length > 0 && this.state.visibleItems.length === 0){
            return <List><ListItem key={this.state.term} isActive={false} >
                Ничего не найдено
            </ListItem></List>
        }

        let nextView = null;
        if (this.props.service === null) {
            nextView = "ServiceView";
        } else {
            nextView = "DateView";
        }
        if (this.props.openWithoutDoctor){
            nextView = "ContactsView";
        }

        const elements = this.state.visibleItems.map((doctor, key) => {
            let props = {
                doctor: doctor.id,
                openWithoutDoctor: 0
            };
            if (doctor.clinics.length === 1) {
                props['clinic'] = (doctor.clinics[0].id)
            }
                return (
                    <ListItem key={key++} isActive={true} onClick={() => {


                        this.props.gotoNextView({
                            breadcrumbName: doctor.name,
                            nextView: nextView,
                            props: props,
                        });
                    }}>

                        <Doctor
                            name={doctor.name}
                            photoUrl={doctor.photoUrl}
                            tags={{
                               // price: parseInt(doctor.price, 10),
                                seesChildren: (doctor.seesChildren),
                                seesAdult: (doctor.seesAdult)
                            }}/>
                    </ListItem>
                );
        });

        return <List>{elements}</List>;
    }

    render() {
        return (
            <div className="appointment-view appointment-view--doctor">
                {this.renderSearchInput()}
                {this.renderContent()}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/doctor.js
 **/